import * as React from "react";
import { NavLink } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import Tooltip from "@material-ui/core/Tooltip";
import { MUIDataTableMeta } from "mui-datatables";
import * as Data from "../../../Data";
import * as DatiFide from "../../../DatiFide";
import * as Glob from "../../../Globale";
import { Trad } from "../../../components";

export const GetExposureLimitsListColumns = (GetBinderVal: (binderlist: Glob.DatiJSON) => string) => [
    {
        name: "ID_FideAffidamento",
        label: "ID",
        options: {
            filter: false,
            sort: false
        }
    },
    {
        name: "AnagDa",
        label: Trad.Trad("Affidatario"),
        options: {
            filter: false,
            sort: false
        }
    },
    {
        name: "AnagA",
        label: Trad.Trad("Affidato"),
        options: {
            filter: false,
            sort: false
        }
    },
    {
        name: "ID_TipoFideAffidamento",
        label: Trad.Trad("Importo"),
        options: {
            filter: false,
            sort: false,
            customBodyRender: (val: string, tableMeta: MUIDataTableMeta) => {
                const rowData = { ...new DatiFide.CDatiFideAffidamento(), ...tableMeta.tableData[tableMeta.rowIndex] };

                return val == Glob.Tipi_FA_Affidamento ? (
                    <>
                        {Trad.TradParam("Provvisorie{1-I}", [rowData.LimiteMassimoContraente_Provvisorie])}
                        <br />
                        {Trad.TradParam("NonProvvisorie{1-I}", [rowData.LimiteMassimoContraente_NonProvvisorie])}
                    </>
                ) : (
                    Trad.TradParam("{1-I}", [rowData.LimiteMassimoContraente])
                );
            }
        }
    },
    {
        name: "Data",
        label: Trad.Trad("Data"),
        options: {
            filter: false,
            sort: false,
            customBodyRender: (val: string) => Trad.Trad(val)
        }
    },
    {
        name: "ScadenzaAffidamento",
        label: Trad.Trad("ScadenzaAffidamento"),
        options: {
            filter: false,
            sort: false,
            customBodyRender: (val: string) => Trad.Trad(val)
        }
    },
    {
        name: "ID_TipoFideAffidamentoEsito",
        label: Trad.Trad("Esito"),
        options: {
            filter: false,
            sort: false,
            customBodyRender: (val: string) => Trad.Trad(val)
        }
    },
    {
        name: "ID_TipoFideAffidamento",
        label: Trad.Trad("Tipo"),
        options: {
            filter: false,
            sort: false,
            customBodyRender: (val: string) => Trad.Trad(val)
        }
    },
    {
        name: "ListaBinderJSON",
        label: Trad.Trad("Binder"),
        options: {
            filter: false,
            sort: false,
            customBodyRender: (val: Glob.DatiJSON) => GetBinderVal(val)
        }
    },
    {
        name: "Edit",
        label: Trad.Trad("Modifica"),
        options: {
            filter: false,
            sort: false,
            setCellHeaderProps: () => ({
                align: "center"
            }),
            setCellProps: () => ({
                align: "center"
            }),
            customBodyRender: (val: string, tableMeta: MUIDataTableMeta) => {
                const rowData = { ...new DatiFide.CDatiFideAffidamento(), ...tableMeta.tableData[tableMeta.rowIndex] };
                const previousRowData = tableMeta.rowIndex > 0 && { ...new DatiFide.CDatiFideAffidamento(), ...tableMeta.tableData[tableMeta.rowIndex - 1] };

                return (
                    (!previousRowData || previousRowData.ID_FideAffidamento != rowData.ID_FideAffidamento) && (
                        <NavLink to={`/anagrafica/${rowData.ID_AnagA}/FideAffidamento/${rowData.ID_FideAffidamento}/${Data.DataValoreCompleta(rowData.RigaInizio)}`}>
                            <Tooltip title={Trad.Trad("Modifica")}>
                                <IconButton aria-label="edit" size="small">
                                    <EditIcon />
                                </IconButton>
                            </Tooltip>
                        </NavLink>
                    )
                );
            }
        }
    }
];



// WEBPACK FOOTER //
// ./src/inar2/components/ExposureLimitsList/ExposureLimitsListColumns.tsx